import type { SubscriptionDetail } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { SECOND_IN_MS, TWENTY_FOUR_H_IN_MS } from 'ae-constants/constants';

import { useRendallApi } from '../use-rendall-api';

export const getSubscriptionsQueryKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'get-subscriptions',
];

// TODO: Rendall, rename SubscriptionDetail or getSubscriptions
export const useSubscriptionsQueryOptions = (
  options?: UseQueryOptions<SubscriptionDetail>,
): UseQueryOptions<SubscriptionDetail> => {
  const api = useRendallApi();
  const [eventSource] = useFeatureFlag('EVENT_LOG_EVENTS_SOURCE');
  const { selectedOrganization } = useOrganizationContext();
  const organizationId = selectedOrganization.id;

  return {
    enabled: Boolean(organizationId),
    gcTime: TWENTY_FOUR_H_IN_MS,
    queryFn: () =>
      api.getSubscriptions(
        { organizationId },
        {
          headers: eventSource ? { 'X-Instance': 'ch_events' } : {},
        },
      ),
    queryKey: getSubscriptionsQueryKey(organizationId),
    staleTime: 20 * SECOND_IN_MS,
    ...options,
  };
};

export const useSubscriptions = (
  options?: UseQueryOptions<SubscriptionDetail>,
) => {
  return useQuery(useSubscriptionsQueryOptions(options));
};
